import {NgModule} from '@angular/core';
import {KorrekturButtonCellComponentComponent} from './korrektur-button-cell-component/korrektur-button-cell-component.component';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {CurrentValuesComponent} from './current-values/current-values.component';
import {CorrectedValuesComponent} from './corrected-values/corrected-values.component';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BsModalService} from 'ngx-bootstrap/modal';


@NgModule({
  declarations: [KorrekturButtonCellComponentComponent, CurrentValuesComponent, CorrectedValuesComponent],
  imports: [
    FontAwesomeModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule
  ],
  entryComponents: [KorrekturButtonCellComponentComponent, CurrentValuesComponent, CorrectedValuesComponent],
  exports: [KorrekturButtonCellComponentComponent, CurrentValuesComponent, CorrectedValuesComponent],
  providers: [BsModalService]
})
export class KorrekturModule {
}
